import { Badge } from '@givebutter/primitives/badge';
import { faFloppyDiskCircleArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Tooltip from 'components/tooltip';

const UnpublishedChangesBadge = () => {
    return (
        <Tooltip.Root>
            <Tooltip.Trigger asChild>
                <Badge className="flex-shrink-0" size="sm">
                    <FontAwesomeIcon icon={faFloppyDiskCircleArrowRight} size="sm" />
                    Unpublished Changes
                </Badge>
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content inverse>
                    <Tooltip.Arrow inverse />
                    <p className="max-w-40 text-xs">
                        Publish your changes by editing your workflow.
                    </p>
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    );
};

export { UnpublishedChangesBadge };
